var map = {
	"./implantbook.png": 1630,
	"./inews.png": 2492,
	"./inewsidem.png": 9665,
	"./inewsids.png": 2016,
	"./infodent.png": 4997,
	"./infomedix.png": 2565,
	"./tabloid.png": 2433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3053;